/**
 * LCW Animated Text
 * Adiciona .is-visible quando o elemento entra no viewport.
 * O estado inicial (opacity:0, translateY) vive no CSS via [data-animate].
 */
class LcwAnimatedText extends HTMLElement {
  connectedCallback() {
    if (window.Shopify && window.Shopify.designMode) {
      this.classList.add('is-visible');
      return;
    }

    if (!this.hasAttribute('data-animate')) {
      this.classList.add('is-visible');
      return;
    }

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      this.classList.add('is-visible');
      return;
    }

    if (!('IntersectionObserver' in window)) {
      this.classList.add('is-visible');
      return;
    }

    const io = new IntersectionObserver(
      (entries, obs) => {
        for (const entry of entries) {
          if (entry.isIntersecting) {
            requestAnimationFrame(() => this.classList.add('is-visible'));
            obs.disconnect();
            break;
          }
        }
      },
      { threshold: 0.15, rootMargin: '0px 0px -8% 0px' }
    );

    io.observe(this);
  }
}

if (!customElements.get('lcw-animated-text')) {
  customElements.define('lcw-animated-text', LcwAnimatedText);
}
